// extracted by mini-css-extract-plugin
module.exports = {"gray30":"#4d4a4f","grayDark":"#363437","demographicSurvey":"style-module__demographicSurvey___3rfoq"};